import React, { Component } from 'react';
import { Column, Row, Grid, cls, ColoredButton } from 'packages/components';
import { VCARD_MATCH_COMMENTS, IN_PROGRESS, NO_COMMENTS, TITLE_COMMENTS, BLUE_BUTTON_COMMENTS, GREEN_BUTTON_COMMENTS } from '../utils/constants';
import { Comment, Player } from '../../../requests/interfaces';
import api from 'src/mundial/requests/api';
import Asset from 'src/requests/apa/Asset';
import Device from 'src/devices/device';
import { Match } from 'src/mundial/requests/interfaces';
import { showSoccerWorldCup } from 'src/utils/Utils';
import { validateImage } from '../utils';
import Translator from 'src/requests/apa/Translator';
import Utils from 'src/utils/Utils';
import './_styles.scss';

interface ICommentsState {
    comments: Comment[],
    players: Player[],
    interval?: NodeJS.Timeout
}
interface ICommentCardProps {
    comment: Comment,
    players: Player[]
    id: string
    classname?: string
}

function CommentCard({ comment, players, id, classname }: ICommentCardProps) {
    const fullComment = Translator.get('match_comments_commentPlayer_label');
    const simpleComment = Translator.get('match_comments_commentNotPlayer_label');
    let player: Player | undefined;
    let labelPlayer: string | undefined;
    let participantType: string | false = comment.subActions.length > 0 && comment.subActions[0].participantType;
    if (comment.subActions[0] !== undefined && participantType === "PERSON") {
        player = players.find((player: Player) => player.id === comment.subActions[0].participantId);
    }
    switch (participantType) {
        case 'PERSON':
            if (player) {
                labelPlayer = fullComment.replace('@description', comment.text).replace('@jugador', player.name).replace('@nacionalidad', player.nationality);
            } else {
                labelPlayer = simpleComment.replace('@description', comment.text);
            }
            break;
        default:
            labelPlayer = comment.text;
    }
    const icon = Asset.get(`match_comments_${comment.type}_img`);
    return (
        <div id={id} key={`comment-${comment.time}-${comment.type}`} className={cls(`${VCARD_MATCH_COMMENTS}-container`, 'focusable', `comment-${comment.time}-${comment.type}`, classname)}>
            <span className={`${VCARD_MATCH_COMMENTS}-time`}>
                {`${comment.timeToDisplay}`}
                {validateImage(icon) ? <img src={icon} alt='icon' className={`${VCARD_MATCH_COMMENTS}-image`} /> : <div className={`${VCARD_MATCH_COMMENTS}-no-image`} />}
            </span>
            <div className={`${VCARD_MATCH_COMMENTS}-text`}>{Utils.cutPlayerString(labelPlayer, 250)}</div>
        </div>
    );
}

function noCommentsCard(): JSX.Element {
    return (
        <div className={`${VCARD_MATCH_COMMENTS}-no-comment`}>
            <span>
                {NO_COMMENTS}
            </span>
        </div>
    )
}

export const Comments = class Comments extends Component<ICommentCardProps, ICommentsState> {
    public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
    constructor(props: ICommentCardProps) {
        super(props);
        this.state = {
            comments: [],
            players: []
        }
        this.goToFirstComment = this.goToFirstComment.bind(this);
        this.goToLastComment = this.goToLastComment.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    async componentDidMount() {
        document && document.removeEventListener("keydown", this.onKeyPress, true);
        document && document.addEventListener("keydown", this.onKeyPress, true);
        const dataMatch: Match = JSON.parse(localStorage.getItem('match') || '{}');
        const updateSecondComents = showSoccerWorldCup();
        let interval: any;
        (window as any).SpatialNavigation.makeFocusable();
        const { match: { params } } = this.props;
        const matchId = params[0].split('/')[3];
        const lineup = await api.getLineup(matchId);
        let players: Player[] = [];
        if (lineup.homeLineup && lineup.awayLineup) {
            players = [...lineup.homeLineup.players, ...lineup.awayLineup.players]
        }
        const comments = await api.getComments(matchId);
        comments.reverse();
        if (dataMatch.status === IN_PROGRESS) {
            interval = setInterval(async () => {
                const newComments = await api.getComments(matchId);
                newComments.reverse();
                this.setState(previous => ({ ...previous, comments:newComments }));
            }, updateSecondComents.interval_time * 1000)
        }
        this.setState({ interval, comments, players });
    }

    componentDidUpdate() {
        (window as any).SpatialNavigation.makeFocusable();
    }

    componentWillUnmount() {
        const { interval } = this.state;
        if (interval) {
            clearInterval(interval);
        }
    }

    goToLastComment() {
        const { comments } = this.state;
        if (comments.length > 0) {
            const firstComment = comments[0];
            (window as any).SpatialNavigation.focus(`.comment-${firstComment.time}-${firstComment.type}`);
        }
    }

    goToFirstComment() {
        const { comments } = this.state;
        if (comments.length > 0) {
            const lastCommentPosition = comments.length - 1;
            const lastComment = comments[lastCommentPosition];
            (window as any).SpatialNavigation.focus(`.comment-${lastComment.time}-${lastComment.type}`);
        }
    }

    onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case "GREEN":
                e.preventDefault();
                e.stopPropagation();
                this.goToLastComment();
                break;
            case "BLUE":
                e.preventDefault();
                e.stopPropagation();
                this.goToFirstComment();
                break;
        }
    }

    render() {
        const { comments, players } = this.state;
        return (
            <Grid className={`${VCARD_MATCH_COMMENTS}-container-father`}>
                <Row className={`${VCARD_MATCH_COMMENTS}-title`}>
                    <span>{TITLE_COMMENTS}</span>
                </Row>
                <Row className={`${VCARD_MATCH_COMMENTS}-contaier-comments`}>
                    <Column lg={9} className={`${VCARD_MATCH_COMMENTS}-column`}>
                        {comments.length > 0 ? comments.map((comment, index )=> <CommentCard id={`comment-${index}`} comment={comment} players={players} classname={index === comments.length - 1 ? 'last' : '' }/>) : noCommentsCard()}
                    </Column>
                    <Column lg={3}>
                        <div className={`${VCARD_MATCH_COMMENTS}-container-buttons`}>
                            <ColoredButton
                                color='green'
                                className={cls(`${VCARD_MATCH_COMMENTS}-green`, 'focusable')}
                                onClick={this.goToLastComment}
                            >
                                {GREEN_BUTTON_COMMENTS}
                            </ColoredButton>
                            <ColoredButton
                                color='blue'
                                className={cls(`${VCARD_MATCH_COMMENTS}-blue`, 'focusable')}
                                onClick={this.goToFirstComment}
                            >
                                {BLUE_BUTTON_COMMENTS}

                            </ColoredButton>
                        </div>
                    </Column>
                </Row>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Comments/index.tsx